import TWalkthroughSelectBusinessHours from './index.vue';

TWalkthroughSelectBusinessHours.install = app => {
  app.component(TWalkthroughSelectBusinessHours.name, TWalkthroughSelectBusinessHours);
};

export default TWalkthroughSelectBusinessHours;
